require('airship/thirdparty/classlist')
require('airship/thirdparty/scrollIntoViewIfNeeded')
require('location-origin')
require('core-js/stable')
require('regenerator-runtime/runtime')
require('smoothscroll-polyfill').polyfill()
